<svelte:body on:item={put_item} />
<script>
    import _ from 'lodash';
    import {toastbox} from '../../../utils.js';
    import {validate_int} from '../../../validators.js';
    import {parameter, network, store} from '../../../stores.js';
    import {createEventDispatcher} from 'svelte';
    import {precision} from '../../../config.js';
    import RalColor from "../../parts/RalColor.svelte";
    import DekoRalColor from "../../parts/DekoRalColor.svelte";

    const dispatch = createEventDispatcher();
    const fixprecision = (value) => Math.ceil(value * precision) / precision;
    const user = store('credential', 'getAuth');
    export let calc;
    export let options;


    const polotno = options.polotno || {
            'Стандарт': 'Стандарт',
            'Антикошка Pet Screen':'Антикошка Pet Screen',
            'Антикошка лайт': 'Антикошка лайт',
            'Антимошка Micro Mesh': 'Антимошка Micro Mesh',
            'Антипыльца противоаллергенная': 'Антипыльца противоаллергенная',
            'Maxi Vision': 'Maxi Vision',
            'Diamond Steel нерж. сталь': 'Diamond Steel нерж. сталь',

        }

    export let put_item = async (e) => {
        let item = e.detail;

        if (item) {
            let title = item.title.split(' ', 3);

            width.set(title[1].split('x')[0]);
            height.set(title[1].split('x')[1]);
            ind1 = item.title.includes('без перемычки') ? 'Нет' : 'Есть';
            ind2.set(title[2]);
            ind3 = Object.keys(polotno).find((el) => item.title.toLowerCase().includes(el.toLowerCase()));

            ind6 = 'пластиковый';
            count.set(+item.quantity);
            comment.set(item.comment);

            fetchData = await fetch($ind2);
            change();
        }
    };

    const color = options.color || {
        'Белый':'Белый',
        'Коричневый(RAL8017)':'Коричневый(RAL8017)',
        'Антрацит':'Антрацит',
        'Цветной':'Цветной',
    }


    const fetch = async (color = 'Белый') => {
        let result = await network.fetch_data('VSN', 'VSN');
        let options = await network.fetch_ind('VSN');

        return {
            name: _.groupBy(result, 'name'),
            ind1: _.groupBy(result, 'ind1'),
            ind2: _.groupBy(result, 'ind2'),
            ind3: _.groupBy(result, 'ind3'),
            edIzmer: _.groupBy(result, 'edIzmer'),
            options,
            result,
        }
    }

    let
        width = parameter('width', '800'),
        height = parameter('height', '1500'),
        ind1 = 'Есть', // перемычка
        ind2 = parameter('color', Object.values(color).shift()), // цвет
        ind3 = Object.keys(polotno).shift(), // полотно

        ind6 = 'пластиковый', // уголок

        // другое
        comment = parameter('comment', ''),
        count = parameter('count', 1)
    ;

    let fetchData = fetch($ind2);
    let
        montage_item,
        montage_price = 1;

    const changeInd2 = () => {fetchData = fetch($ind2)};
    const changeHeight = _.debounce(() => {
        if ($height > 1400 && ind1 !== 'Есть') {
            ind1 = 'Есть';
            toastbox('toast-ind1', 3000);
        }
    }, 1000);

    // расчёт стоимости
    const change = _.debounce(async () => {
        let data = await fetchData;

        let
            quantity = +$count,

            w = +$width,
            h = +$height,
            packing_items = []
        ;

        let result = {
            type: 'VSN',
            name: 'vsn',
            subname: [
                w + 'x' + h, ' ',
                $ind2, ' ', ind3, ' ',
                ind1 === 'Нет' ? 'без перемычки' : 'с перемычкой',
            ].join(''),
            title: [
                'VSN', ' ', w + 'x' + h, ' ',
                $ind2, ' ', ind3, ' ',
                ind1 === 'Нет' ? 'без перемычки' : 'с перемычкой',
            ].join(''),
            params: {
                 ind1: [
                     ind1 === 'Нет' ? 'без перемычки' : 'с перемычкой',
                 ].join(''),
                ind2: $ind2,
                ind3: ind3,
                ind4: $width,
                ind5: $height,
            },
            price: {rozn: 0, opt: 0, sebest: 0,},
            quantity,
            maxDay: 0,
            materials: {},
            comment: $comment,
            vStrukture: 121,
        };

        _.forEach(data.result, function(item) {
            let name = item.name.toLowerCase();

            let price = {rozn: 0, opt: 0, sebest: 0}
            let kolvo = 0;

            if (
                name.includes('профиль vsn') &&  name.includes($ind2.toLowerCase()) ||
                name.includes('шнур фиксирующий')
            ) {
                kolvo = (((w - 54) * 2 + (h - 54) * 2) / 1000).toFixed(3);

            }

            if (name.includes('угол')) {
                kolvo = (4).toFixed(3);
            }

            if (name.includes('перемычка мс')) {
                if (ind1 === 'Есть') {

                    kolvo = ((w - 44+5) / 1000).toFixed(3);


                }
            }

            if (name.includes('крепление мс перемычки')) {
                if (ind1 === 'Есть') {
                    kolvo = (2).toFixed(3);
                }
            }


            if (name.includes('комплект')) {
                kolvo = (1).toFixed(3);
            }

            if (
                (
                    name.includes('сетка москитная') ||
                    name === 'наносетка'||
                    name.includes('оберег')||
                    name.includes('антикошка')||
                    name.includes('нтипыльца')||
                    name.includes('micro')||
                    name.includes('vision')||
                    name.includes('нерж. сталь')
                ) && name.indexOf(ind3.toLowerCase()) >= 0
            ) {
                kolvo = (w * h / 1000000).toFixed(3);
            }



            if (name.includes('работа пс')) {
                if (
                    ind3.toLowerCase().includes('антикошка') ||
                    ind3.toLowerCase().includes('аллергенная') ||
                    ind3.toLowerCase().includes('оберег') ||
                    ind3.toLowerCase().includes('наносетка')||
                    ind3.toLowerCase().includes('нерж. сталь')
                ) {
                    kolvo = (1).toFixed(3);
                }
            }
            else if (name.includes('работа')) {
                if (
                    ind3.toLowerCase().includes('стандарт') ||
                    ind3.toLowerCase().includes('ppe') ||
                    ind3.toLowerCase().includes('антимошка') ||
                    ind3.toLowerCase().includes('максимальный обзор') ||
                    ind3.toLowerCase().includes('Maxi Vision'.toLowerCase()) ||
                    ind3.toLowerCase().includes('нет')
                ) {
                    kolvo = (1).toFixed(3);
                }
            }

            if (kolvo) {
                price['rozn'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.price);
                price['opt'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.opt_price);
                price['sebest'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.sebestomost);

                result.maxDay = Math.max((result.maxDay ?? 0), parseInt(item.ind1) || 0);

                result.materials[item.name] = {
                    order: +item.poryadok,
                    id: item.idTovar,
                    spis: item.procentSpisania,
                    type: item.edIzmer,
                    oprice: {
                        rozn: (+item.price).toFixed(2),
                        opt: (+item.opt_price).toFixed(2),
                        sebest: (+item.sebestomost).toFixed(2),
                    },
                    price,
                    quantity,
                    count: (+kolvo).toFixed(3)
                };
            }

            if (name.includes('монтаж')) {
                montage_item = item;
            }
            if (name.includes('упаковка')) {
                packing_items.push(item);
            }

        });

        result.price.rozn = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'rozn').toFixed(2);
        result.price.opt = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'opt').toFixed(2);
        result.price.sebest = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'sebest').toFixed(2);


        if (montage_item) {
            let mprice = Math.round((result.price.rozn / quantity) / 100 * montage_item.procentSpisania / 100) * 100;
            montage_price = +(montage_item.opt_price > mprice ? montage_item.opt_price * quantity : mprice * quantity).toFixed(2);
            dispatch('mounting', {item: montage_item, price: montage_price});
        }

        dispatch('packing', {items: packing_items, multiplier: w * h / 1000000 });
        dispatch('item', result);
    }, 250);

    change();
</script>

{#await fetchData}
    <div class="card-body">
        <div class="text-center">
            <p>Загрузка..</p>
        </div>
    </div>
{:then data}
    <!--<pre>{JSON.stringify(data.edIzmer["кв.м"], null, 4)}</pre>-->
    <div class="card-body" on:keyup={change} on:paste={change} on:change={change}>
        <div class="row">
            {#if APP_TYPE === 'axis-one'}
                {@const filename = ($ind2 === 'Белый(9016RAL)' ?
                        '1inw.jpg' : ($ind2 === 'Анодированный(коньяк)' || $ind2 === 'Коричневый(RAL8017)' || $ind2 === 'Антрацит(7016RAL)' ?
                                '2inb.jpg' : 'inc.jpg'
                        )
                )}
                <div class="col-12  text-center d-flex order-last  order-sm-first justify-content-around">
                    <img style="max-height: 250px"
                         class="img-fluid p-3"
                         src="https://225304.selcdn.ru/axisdb/photo_2026-04-23_20-24-21_20260423182424-big.webp?{filename}"
                         alt="img"
                    />




                </div>
            {/if}
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Москитное полотно</label>
                        <select class="form-control form-select" bind:value={ind3}>
                            {#each Object.entries(polotno) as [value, name]}
                                <option value="{value}">{name}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Цвет</label>
                        <select class="form-control form-select" bind:value={$ind2} on:change={() => {changeInd2(); change()}}>
                            {#each Object.entries(color) as [value, name]}
                                <option value="{value}">{name}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">

            <div class="col-12">
                <div class="form-group boxed">
                     <div class="alert alert-outline-danger">
                         К расчету принимаются только размеры светового проема!
                     </div>
                </div>
            </div>

            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">250 ≥ Шир., мм ≥ { options.max && options.max.width ? options.max.width : 1300 }</label>
                        <input type="number" class="form-control" step="10" min="250" max="{ options.max && options.max.width ? options.max.width : 1300 }" bind:value={$width} use:validate_int={$width}>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">250 ≥ Выс., мм ≥ { options.max && options.max.height ? options.max.height : 2400 }</label>
                        <input type="number" class="form-control" step="10" min="250" max="{ options.max && options.max.height ? options.max.height : 2400 }" bind:value={$height} use:validate_int={$height} on:change={changeHeight}>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Перемычка</label>
                        <select class="form-control form-select" bind:value={ind1}>
                            <option value="Есть">Есть</option>
                            <option value="Нет">Нет</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Уголок</label>
                        <select class="form-control form-select" bind:value={ind6}>
                            <option value="пластиковый">Пластик</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>



        <div class="row">
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Количество</label>
                        <input type="number" class="form-control" min="1" bind:value={$count} use:validate_int={count}>
                    </div>
                </div>
            </div>
            <RalColor color={$ind2} bind:comment={$comment}/>
            <DekoRalColor color={$ind2} bind:comment={$comment}/>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <div class="input-wrapper">
                            <label class="form-label">Примечание</label>
                            <textarea class="form-control" bind:value={$comment}></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
{/await}

<div id="toast-ind1" class="toast-box toast-top bg-danger">
    <div class="in">
        <div class="text">
            При высоте больше 1400 мм рекомендуется поставить перемычку
        </div>
    </div>
</div>
